import ComponentManager from "../../componentFramework";

// TODO (Michael) Clean this up. Not all of this should necessarily be in this file.

@ComponentManager.register()
export default class SiteChecks {
	public static componentStyleClass = "siteChecks";
	// private siteChecksElem: HTMLElement;

	constructor({}: HTMLElement) {
		// this.siteChecksElem = element;

		// TODO Upgrade this code. Cleanup and remove use of JQuery too.

		//Setup on-click toggle for icon/coloring in general error layout
		$(".contentMessage:not(.severity-success)").on("click", (event) => {
			if ($(event.target).hasClass("icon")) {
				$(event.delegateTarget).toggleClass("severity-success");
				return false;
			}
			return true;
		});
		$(".contentMessage__outer.exception").on("click", (event) => {
			if (!$(event.target).is("a")) {
				const $delegate = $(event.delegateTarget);
				$delegate.find(".traceDots").toggle();
				$delegate.find(".traceText").toggle("fast");
				return false;
			}
			return true;
		});
	}

	@ComponentManager.on("removed")
	protected componentRemoved() {
		//this.siteChecksElem = undefined;
	}
}
